import React, { Component } from 'react';
import { Button, ButtonProps, Icon, Popup } from 'semantic-ui-react';

interface BtnCustomProps extends ButtonProps {
  customTrigger?: React.ReactNode,
  toolbarButtonStyle?: Object,
  popupStyle?: Object
}

const defaultToolbarBtnStyle = {
  background: 'transparent',
  cursor: 'pointer',
  padding: '5px 7px'
};

const defaultPopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

class ToolbarButton extends Component<BtnCustomProps> {

  constructor(props: BtnCustomProps) {
    super(props);

  }

  render(): React.ReactNode {

    const {
      iconName,
      iconSize,
      disabled = false,
      onClick,
      dataTooltip,
      customTrigger,
      toolbarButtonStyle = {},
      popupStyle = {},
      ...restProps
    } = this.props;

    const ToolbarBtnStyle = {
      ...defaultToolbarBtnStyle,
      ...toolbarButtonStyle
    };

    const BtnPopupStyle = {
      ...defaultPopupStyle,
      ...popupStyle
    };

    return (
        <Button type="button" icon {...restProps}
                           disabled={disabled}
                           style={ToolbarBtnStyle}
                           onClick={onClick}
        >

          <Popup
              popperModifiers={{ preventOverflow: { boundariesElement: "window" } }}
              trigger={this.renderTrigger()}
              content={dataTooltip}
              size='small'
              position='top center'
              style={BtnPopupStyle}
              inverted
          />
        </Button>
    );
  }

  renderTrigger = (): React.ReactNode => {

    const { customTrigger, iconName, iconSize } = this.props;

    if (customTrigger) {
      return customTrigger;
    } else {
      return <Icon name={iconName} size={iconSize} />;
    }
  }
}


export default ToolbarButton;
